import { all, put, select, takeEvery } from 'redux-saga/effects';
import * as Actions from './action';
import {
  getOrgStationsApi,
  getMarketApi,
  fetchIHeartTTWNMarkets
} from '../../../../helpers/marketApi';
import { showToast } from '../notification';
import { setSelection } from '../geoSelector/actions';
import { updateCampaign, namespace as campaignNamespace } from '../campaign';
import {
  FAILED, IHEART_ORG_ID, UNRATED_FIELDS,
} from '../../../../helpers/constant';
import { shortenIdTree } from '../../../../helpers/formatData';
import { TYPE_STANDARD } from 'components/Geofence/constant.js';

import { get, pick, isEmpty, sortBy } from 'lodash';
import { modules } from 'veritone-redux-common';

const {
  user: { selectUser }
} = modules;
const { LOADING, LOADED, ERROR } = Actions.Status;

//market dataSetType
export const NEILSEN_MARKETS = 'Neilsen';
export const IHEART_MARKETS = 'iHeart';

function* loadMarkets() {
  
  const config = yield select(state => state.config);
  const currentUser = yield select(selectUser);
  const orgId = get(currentUser, 'organization.organizationId');
  yield put(Actions.setLoadStatus(LOADING));

  const stationFetchResults = yield getOrgStationsApi(config.urlApi);
  const stationList = get(stationFetchResults, 'data');
  if (stationList) {
    const useIheartMarkets = get(currentUser, 'organization.kvp.features.attribute.displayCustomMarkets') === 'enabled';
    const marketDataSet = useIheartMarkets ? IHEART_MARKETS : NEILSEN_MARKETS;
    const { stationCallsigns, callsignStationHashMap } = stationList.reduce((acc, station) => {
      const { stationCallsigns, callsignStationHashMap } = acc;
      const stationCallSign = get(station, 'details.stationCallSign');
      const stationBand = get(station, 'details.stationBand');
      if (stationCallSign) {
        const callsign = stationBand ? `${stationCallSign}-${stationBand}` : stationCallSign;
        stationCallsigns.push(callsign);
        const stationDetail = get(station, 'details', {});
        callsignStationHashMap[callsign] = {
          ...pick(station, ['id', 'name', 'sourceTypeId']),
          ...pick(stationDetail, ['liveTimezone', 'homeMarketId', 'marketIds', "stationCallSign", "stationBand"])
        }
      }
      return acc;
    }, {
      stationCallsigns: [],
      callsignStationHashMap: {}
    });
    const marketFetchResult = yield getMarketApi(config.urlApi, marketDataSet, stationCallsigns);
    const marketsData = get(marketFetchResult, 'data');
    if (marketsData) {
      const marketsListData = Object.values(marketsData);
      let marketList = marketsListData.reduce((acc, market) => {
        const stations = get(market, 'stations', []);

        //merge with callsignStationHashMap and uniq
        const stationHashMap = stations.reduce((acc, station) => {
          const { callsign } = station;
          if (!callsignStationHashMap[callsign] ) { return acc; }
          if (acc[callsign]) {
            acc[callsign] = {
              ...acc[callsign],
              ...station
            }
          } else {
            acc[callsign] = {
              ...callsignStationHashMap[callsign],
              ...station
            }
          }
          return acc;
        }, {});
        
        //Only market that include org stations (callsignStationHashMap[callsign] exist) will be listed 
        if(!isEmpty(stationHashMap)) {
          const stationList =  Object.values(stationHashMap);
          let sortedStationList = sortBy(stationList, 'name');

          if(market['ttwnMarketName'] && orgId === IHEART_ORG_ID) {
            const ttwnStation = {
              id: market.id,
              name: market.ttwnMarketName,
              isTTWNStation: true
            };

            sortedStationList = [...sortedStationList, ttwnStation];
          }

          market.stations = sortedStationList;
          acc.push(market);
        }

        return acc;
      }, []);

      if (orgId === IHEART_ORG_ID) {
        const iHeartTTWNMarkets = yield fetchIHeartTTWNMarkets(config.urlApi);
        const convertedIHeartMarkets = iHeartTTWNMarkets.reduce((acc, item) => {
          if(item.type !== TYPE_STANDARD) {
            const convertedMarket = {
              ...item, 
              stations: [
                {
                  id: item.id,
                  isTTWNStation: true,
                  name: item.ttwnMarket
                }
              ]
            }
            return [...acc, convertedMarket]
          }

          return acc;
        }, [])
        marketList = marketList.concat(convertedIHeartMarkets)
      }

      marketList = sortBy(marketList, 'name');      
      yield put(Actions.setMarkets(marketList));
      return yield put(Actions.setLoadStatus(LOADED));
    }
  }

  yield put(Actions.setLoadStatus(ERROR));
  yield put(showToast({
    message: 'Error loading markets',
    action: 'Dismiss',
    type: FAILED
  }))
}

function* setDefaultMarkets(action) {
  const { marketType } = action.payload;
  const { namespace: marketNamespace, Status } = Actions;
  const marketStore = yield select(state => get(state, marketNamespace, {} ));
  if (marketStore.status === Status.LOADED) {
    const marketList = [...marketStore.data];
    const unratedField = UNRATED_FIELDS[marketType];
    const { selectedGeoIds, unratedIds, selectedStationIds} = marketList.reduce((acc, market) => {
      const { selectedGeoIds, unratedIds, selectedStationIds } = acc;
      if (market.type !== marketType && market.type === TYPE_STANDARD && market[unratedField]) { return acc; } //continue to next market
      const { parentIdTree } = market;
      if (market.type === marketType) {
        selectedGeoIds.push(parentIdTree);
      } else if (market.type === TYPE_STANDARD && !market[unratedField]){
        const idTree = shortenIdTree(parentIdTree);
        unratedIds.push(idTree);
      }
      const stations = get(market, 'stations', []);
      stations.forEach(station => {
        selectedStationIds.push(station.id);
      })
      return acc;
    }, {
      selectedGeoIds: [],
      unratedIds: [],
      selectedStationIds: []
    });
    yield put(setSelection({
      selectionType: marketType,
      selectedIds: selectedGeoIds,
      unratedIds
    }));
    const editingCampaign = yield select(state => get(state, [campaignNamespace, 'byId', 'editing']));
    if (editingCampaign) {
      yield put(updateCampaign({
        campaign_id: 'editing',
        stationList: selectedStationIds
      }))
    }
  }
}

export default function* market() {
  const { ActionType } = Actions;
  yield all([
    takeEvery(ActionType.LOAD_MARKETS, loadMarkets),
    takeEvery(ActionType.SET_DEFAULT_MARKETS, setDefaultMarkets)
  ])
}
